<template>
  <div>
    <template v-for="(item, index) in menuList">
      <div style="text-align: center;" :key="index">
        <Dropdown transfer v-if="item.children.length !== 0" placement="right-start" :key="index" @on-click="changeMenu">
          <Button style="width: 70px;margin-left: -5px;padding:10px 0;" type="text" ghost>
            <Icon :size="20" :color="iconColor" type="ios-menu-outline"></Icon>
          </Button>
          <DropdownMenu style=" width: 200px; " slot="list">
            <template v-for="(child, i) in item.children">
              <DropdownItem :name="child.name" :key="i"><Icon :type="child.icon"></Icon><span style="padding-left:10px;">{{ itemTitle(child) }}</span></DropdownItem>
            </template>
          </DropdownMenu>
        </Dropdown>

      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'sidebarMenuShrink',
  props: {
    menuList: {
      type: Array
    },
    iconColor: {
      type: String,
      default: 'white'
    },
    menuTheme: {
      type: String,
      default: 'darck'
    }
  },
  methods: {
    changeMenu (active) {
      let menu = this.menuList;
      let menuI = this.queckChildMenu(menu, active)
      try{
        if (active === "workOrder") {
          active = menu[menuI.i].children[menuI.j].children[0].children[0].name
        } else if (menu[menuI.i].children[menuI.j]&&menu[menuI.i].children[menuI.j].children !== undefined) {
          active = menu[menuI.i].children[menuI.j].children[0].name
        }
      }catch (e){
        console.log(e)
      }
      this.$emit('on-change', active);
    },
    queckChildMenu(menu, e) {
      let arr = {}
      for (let i = 0; i < menu.length; i++) {
        for (let j = 0; j < menu[i].children.length; j++) {
          if (menu[i].children[j].name === e) {
            return arr = {i, j};
          }
        }
      }
    },
    itemTitle (item) {
      if (typeof item.title === 'object') {
        return this.$t(item.title.i18n);
      } else {
        return item.title;
      }
    }
  }
};
</script>
